var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SignInBody',{attrs:{"clazz":"full-page"},scopedSlots:_vm._u([{key:"formSectionBody",fn:function(){return [_c('router-view')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }